import React from 'react';

import { Button } from 'react-bootstrap';
import '../../../css/form.css';

import Loading from '../../Layout/Loading';

import {
  addLineToFlashbag,
} from '../../../Store/Action/flashbag';

/**
 * FormButton
 */
class FormButton extends React.Component {

  /**
   * TODO may change default to restriction using propTypes
   * default Props used in the class.
   */
  static defaultProps = {
    as: 'button',
    path: () => {},
    onClick: () => {},
    request: {}
  }

  constructor(props) {
    super(props);

    if(props.request && props.request.request) {
      this.request = this.props.modalHandler.addVerificationWithCallback(props.request.request, this.postLoad, this.postLoadFailure, true);
    }

    //the state of the component
    this.state = {
      loading: false,
      loaded: false,
      loadingFailure: false,
      options: [],
    }
  }

  startRequest() {
    if(this.props.request.requestRequire(this.props.getValues, this.props.getExtraValues)) {
      let myArguments = this.props.request.requestArguments(this.props.getValues, this.props.getExtraValues);
      this.setState({
        loading: true,
      }, () => {
        // console.log('test');
        this.request(...myArguments);
      });
    }
  }

  /**
   * callback collecting the result of the call
   */
  postLoad = (data) => {
    this.setState({
      loaded: true,
      loading: false,
      loadingFailure: false,
    }, () => {
      this.props.request.postRequestCallback.forEach((item, i) => {
        switch (item.type) {
          case "flashbag":
            this.props.dispatch(addLineToFlashbag(item.message, item.flashbagType));
            break;
          case "reload":
            window.location.reload()
            break;
          default:

        }
      });
    })
  }

  /**
   * callback collecting the result of the call
   */
  postLoadFailure = (msg) => {
    this.setState({
      loaded: true,
      loading: false,
      loadingFailure: true,
    }, () => {
      this.props.request.postRequestCallbackFailure.forEach((item, i) => {
        switch (item.type) {
          case "flashbag":
            this.props.dispatch(addLineToFlashbag(item.message, item.flashbagType));
            break;
          case "reload":
            window.location.reload()
            break;
          default:
        }
      });
    })
  }

  displayButtonAsA() {
    return (
      <div className={`d-flex col-md-${this.props.fieldColMd} container-form-row justify-content-center`}>
        <a
          className="col-6 col-md-3 button-form-row btn btn-my-secondary-outline"
          href={this.props.path(this.props.getValues, this.props.getExtraValues)}>
          {this.props.label}
        </a>
      </div>
    )
  }

  displayButtonAsButton() {
    return (
      <div className={`d-flex container-form-row justify-content-center`}>
        <Button
          className="col-6 col-md-3 button-form-row"
          variant="my-secondary-outline"
          onClick={() => this.props.onClick(this.props.getValues, this.props.getExtraValues)}>
          {this.props.label}
        </Button>
      </div>
    )
  }

  displayButtonAsRequest() {
    return (
      <div className={`d-flex container-form-row justify-content-center`}>
        <Button
          className="col-6 col-md-3 button-form-row"
          variant="my-secondary-outline"
          onClick={() => this.startRequest()}>
          <div className="d-flex flow-row justify-content-center">
            <div className="d-flex col-auto no-gutters justify-content-center">{this.displayLoading()}</div>
            <div className="d-flex col-auto no-gutters justify-content-center align-self-center">{this.props.label}</div>
          </div>
        </Button>
      </div>
    )
  }

  displayLoading() {
    if(this.state.loading) {
      return (
        <Loading container="parent" containerClassName="loading-form-row" size="small"/>
      )
    }
  }

  displayButton() {
    switch (this.props.as) {
      case 'a':
        return this.displayButtonAsA();
      case 'button':
        return this.displayButtonAsButton();
      case 'request':
        return this.displayButtonAsRequest();
      default:
        console.log("Button type is wrong : " + this.props.as);
    }
    return null;
  }

  /**
   * Main render method for React Component
   */
  render() {
    return this.displayButton();
  }
}

export default FormButton;
